// Authentication utility functions

/**
 * Get authentication token from storage
 * Checks multiple storage locations for compatibility
 */
export const getAuthToken = () => {
  const token = localStorage.getItem('token') ||
               sessionStorage.getItem('token') ||
               localStorage.getItem('authToken') ||
               sessionStorage.getItem('authToken');

  if (!token) {
    console.warn('No authentication token found in storage');
  }

  return token;
};

/**
 * Set authentication token in storage
 * @param {string} token - JWT token
 * @param {boolean} remember - If true, stores in localStorage, otherwise sessionStorage
 */
export const setAuthToken = (token, remember = true) => {
  if (remember) {
    localStorage.setItem('authToken', token);
    localStorage.setItem('token', token); // For backward compatibility
  } else {
    sessionStorage.setItem('authToken', token);
    sessionStorage.setItem('token', token);
  }
};

/**
 * Remove authentication token from storage
 */
export const removeAuthToken = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('authToken');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('authToken');
};

/**
 * Check if user is authenticated
 */
export const isAuthenticated = () => {
  return !!getAuthToken();
};

/**
 * Get user info from token (decoded JWT)
 * Note: This doesn't verify the token, just decodes it
 */
export const getUserFromToken = () => {
  const token = getAuthToken();
  if (!token) return null;

  try {
    // Decode JWT (base64)
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

/**
 * Create authorization header for API requests
 */
export const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};
